import React from 'react'

import { convertMarkdownLinks } from '../../utils/'
import { SECTION_TYPES } from '../../TDAs/constants'
import {
  DisclaimerSection,
  DisclaimerText,
  DisclaimerType
} from '../../models/tda.model'
import styles from './Disclaimer.module.scss'

interface DisclaimerPropsType {
  disclaimer?: DisclaimerType
}

// convert disclaimer text to array of text and links
const handleMarkdownLinks = (disclaimerText: string) => {
  const textHandler = (parsedText: string) => {
    return (
      <span className={styles.disclaimerInlineText} key={parsedText.substring(0, 9)}>{parsedText}</span>
    )
  }
  const linkHandler = (parsedLinkHref: string, parsedLinkText: string) => {
    return (
      <a href={parsedLinkHref} target='_blank' rel='noopener noreferrer' key={parsedLinkText.substring(0, 9)}>{parsedLinkText}</a>
    )
  }
  return convertMarkdownLinks(disclaimerText, textHandler, linkHandler)
}

const Disclaimer = (props: DisclaimerPropsType) => {
  const { disclaimer} = props
  if (!disclaimer) {
    return null
  }

  return (
    <div className={`${styles.disclaimerContainer} ie-height-fix`}>
      {
        disclaimer.map(({ content }: DisclaimerSection, sectionIndex) => (
          <div className={styles.disclaimerTextSection} key={`section${sectionIndex}Children${content.length}`}>
            {
              content.map(({ content, type }: DisclaimerText) => {
                const textClass = type === SECTION_TYPES.HEADER ? styles.disclaimerHeaderText : styles.disclaimerBodyText
                return (
                  <p className={textClass} key={content.substring(0, 9)}>{handleMarkdownLinks(content)}</p>
                )
              })
            }
          </div>
          )
        )
      }
    </div>
  )
}

export default Disclaimer;
